<button fxFlex mat-flat-button color="primary" (click)="helpClick()">
    <mat-icon>help_center</mat-icon>{{ "HELP.BUTTON_LABEL" | translate }}
</button>
